<template>
  <div>
    <div class="error-container pl-3">
      <div class="d-flex">
        <span class="color-primary-4 font-16 font-weight-bold flex-grow-1">
          ({{ errors.length }}) Documentos con Error
        </span>
        <div
          class="d-flex align-items-center px-2 rounded-pill border-color--primary-4 cursor-pointer"
          @click="$emit('close')"
        >
          <em class="fa fa-times-circle mr-2 color-primary-4" />
          <span class="color-primary-4 font-16">Cerrar</span>
        </div>
      </div>
      <div v-if="errors.length > 0">
        <ul class="m-0 pl-4">
          <li
            v-for="(item, index) in errors"
            :key="`error-container-${index}`"
            class="color-primary-4"
          >
            <span class="font-16 font-weight-bold">{{ item.fileName }}</span>
            -
            <span class="font-16">{{ item.description }}</span>
          </li>
        </ul>
      </div>
      <div class="d-flex flex-column color-primary-4 align-items-end font-20">
        <em class="fa fa-caret-up mb-n1 cursor-pointer" />
        <em class="fa fa-caret-down cursor-pointer" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'FileError',
  props: {
    errors: {
      type: Array,
      default: () => [],
    },
  },
};
</script>

<style scoped lang="scss">
@import '@/shared/scss/config/_colors.scss';
.error-container {
  border-radius: 5px 5px 0px 5px;
  padding: 10px;
  background: map-get($colors, 'pink-1');
}
</style>
